/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_OutInputs */

const en_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const he_sign_out = /** @type {(inputs: Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התנתקות`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Sign_OutInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const sign_out = /** @type {((inputs?: Sign_OutInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_OutInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sign_out(inputs)
	return he_sign_out(inputs)
});